import {Component} from '@angular/core';
import {AuthenticationService} from '@iw-shared/core/services/authentication.service';
import {AccountBackendUsersService} from '@account/shared/account-backend-users/services/account-backend-users.service';
import {faSignIn} from "@fortawesome/free-solid-svg-icons";
import {FormHandler} from "@iw-shared/form/models/form-handler";

@Component({
  selector: 'page-authentication-password-reset',
  templateUrl: './page-authentication-password-reset.component.html',
  styleUrls: ['./page-authentication-password-reset.component.scss']
})
export class PageAuthenticationPasswordResetComponent {

  formHandler: FormHandler = new FormHandler();

  constructor(private authenticationService: AuthenticationService, private accountBackendUsersService: AccountBackendUsersService) {

  }

  resetUserPassword(params: { password: string }) {
    this.accountBackendUsersService.update({
      id: this.authenticationService.getPayloadFromInjectionToken().userId,
      password: params.password
    }).subscribe(
      r => {
        this.formHandler.setFormStatus({formStatus: 'success'});
      }
    );
  }

  protected readonly faSignIn = faSignIn;
}
